import { makeGroupsWithPropertiesQuickFetchKey } from './cacheKeys';
import { fetchGroupedProperties } from './properties';
import { wrapPromise } from 'persist-promise/wrapPromise';

export const propertiesPersistedPromise = wrapPromise({
  namespace: 'FDSR',
  entityName: 'properties',
  deepFreeze: true,
  toCacheKey: makeGroupsWithPropertiesQuickFetchKey,
  fetch: fetchGroupedProperties,
});
